var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('ValueComparison',{staticStyle:{"height":"69px"},attrs:{"value":_vm.selectReportValue(_vm.widgetId),"comparison":_vm.comparison,"comparisonVersusText":'with Ovation'}}):_c('ValueComparisonLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }